
/*
Generate unique ids to identify each sortable element on the page
 */
angular.module('smart-table').factory('stUniqueId', function() {
  var id;
  id = 0;
  return {
    generate: function() {
      return id++;
    }
  };
});

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2hvbWUvZG9vemVyL3Byb2plY3RzL3N0LW11bHRpLXNvcnQvc3JjL3N0X2VsZW1lbnRfaWQuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL2hvbWUvZG9vemVyL3Byb2plY3RzL3N0LW11bHRpLXNvcnQvc3JjL3N0X2VsZW1lbnRfaWQuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7O0FBR0EsT0FBTyxDQUFDLE1BQVIsQ0FBZSxhQUFmLENBRUEsQ0FBQyxPQUZELENBRVMsWUFGVCxFQUV1QixTQUFBO0FBQ3JCLE1BQUE7RUFBQSxFQUFBLEdBQUs7U0FFTDtJQUNFLFFBQUEsRUFBVSxTQUFBO2FBQUcsRUFBQTtJQUFILENBRFo7O0FBSHFCLENBRnZCIn0=
